export default __webpack_public_path__ + "static/media/icon_bubble_chart.b5c1222d.svg";